import BaseRequest from './BaseRequest';
import HTTPRequest from '../HTTPRequest';

export default class Events extends BaseRequest {
    /**
     * Events constructor
     *
     * @param {string} requestMode
     * @param {string} providerId
     * @param {string} customerId
     * @param {boolean} auth
     * @param {boolean} fowardRequest
     */
    constructor(
        requestMode = 'customer',
        providerId = '',
        customerId = '',
        auth = true,
        fowardRequest = false,
    ) {
        super(requestMode, providerId, customerId, auth, fowardRequest);
        this.setClassName('Events');
        this.setEndpoint('events');
    }

    /**
     * @param {string} eventId
     * @param {string} membershipId
     * @param {string} customerId
     * @return {object}
     */
    async register(eventId = '', membershipId = '', customerId = '') {
        if (customerId == '') {
            customerId = this.getCustomerId();
        }

        let body = {
            customer: customerId,
        };
        if (membershipId != '') {
            body['customer_membership'] = membershipId;
        }
        if (eventId != '') {
            body['event'] = eventId;
        }

        let request = new HTTPRequest(
            'POST',
            `${this.getEndpoint()}/${eventId}/register`,
            this.getHeaders(),
            {},
            body,
        );
        if (this.getForwardRequest()) {
            request = this.buildForwardRequest(
                this.getClassName(),
                'register',
                {
                    eventId: eventId,
                    membershipId: membershipId,
                    customerId: customerId,
                },
            );
        }

        return await request.sendRequest();
    }

    /**
     * @param {string} eventId
     * @param {string} customerId
     * @return {object}
     */
    async unregister(eventId = '', customerId = '') {
        if (customerId == '') {
            customerId = this.getCustomerId();
        }

        let request = new HTTPRequest(
            'POST',
            `${this.getEndpoint()}/${eventId}/unregister`,
            this.getHeaders(),
            {},
            {
                customer: customerId,
            },
        );
        if (this.getForwardRequest()) {
            request = this.buildForwardRequest(
                this.getClassName(),
                'unregister',
                {
                    eventId: eventId,
                    customerId: customerId,
                },
            );
        }

        return await request.sendRequest();
    }

    /**
     * @param {string} eventId
     * @param {string} customerId
     * @return {object}
     */
    async joinWaitlist(eventId = '', customerId = '') {
        if (customerId == '') {
            customerId = this.getCustomerId();
        }

        let request = new HTTPRequest(
            'POST',
            `${this.getEndpoint()}/${eventId}/join_waitlist`,
            this.getHeaders(),
            {
                expand: 'position',
            },
            {
                customer: customerId,
            },
        );
        if (this.getForwardRequest()) {
            request = this.buildForwardRequest(
                this.getClassName(),
                'joinWaitlist',
                {
                    eventId: eventId,
                    customerId: customerId,
                },
            );
        }

        return await request.sendRequest();
    }

    /**
     * @param {string} eventId
     * @param {string} customerId
     * @return {object}
     */
    async leaveWaitlist(eventId = '', customerId = '') {
        if (customerId == '') {
            customerId = this.getCustomerId();
        }

        let request = new HTTPRequest(
            'POST',
            `${this.getEndpoint()}/${eventId}/leave_waitlist`,
            this.getHeaders(),
            {},
            {
                customer: customerId,
            },
        );
        if (this.getForwardRequest()) {
            request = this.buildForwardRequest(
                this.getClassName(),
                'leaveWaitlist',
                {
                    eventId: eventId,
                    customerId: customerId,
                },
            );
        }

        return await request.sendRequest();
    }

    /**
     * @param {string} eventId
     * @param {string} membershipId
     * @param {string} customerId
     * @param {boolean} selectDropIn
     * @param {string} returnTo
     * @return {object}
     */
    async initiatePurchase(
        eventId = '',
        membershipId = '',
        customerId = '',
        selectDropIn = false,
        returnTo = '',
    ) {
        if (customerId == '') {
            customerId = this.getCustomerId();
        }
        const returnToUrl = this.buildReturnUrl(returnTo, {
            customer_id: customerId,
            event_id: eventId,
            membership_id: membershipId,
            provider_id: this.getProviderId(),
        });

        let body = {
            customer: customerId,
            return_to: returnToUrl,
            select_drop_in: selectDropIn,
        };
        if (membershipId != '') {
            body['customer_membership'] = membershipId;
        }

        let request = new HTTPRequest(
            'POST',
            `${this.getEndpoint()}/${eventId}/initiate_purchase`,
            this.getHeaders(),
            {},
            body,
        );
        if (this.getForwardRequest()) {
            request = this.buildForwardRequest(
                this.getClassName(),
                'initiatePurchase',
                {
                    eventId: eventId,
                    membershipId: membershipId,
                    customerId: customerId,
                    selectDropIn: selectDropIn,
                    returnTo: returnTo,
                },
            );
        }

        return await request.sendRequest();
    }
}
